export const withdraws = {
	title: "Saques, Antecipações e Boletos",
	filename: "saques-antecipacoes-boletos",
	table: {
		datetime: "Data da solicitação",
		type: "Tipo",
		status: "Status",
		username: "Usuário",
		vendor: "Vendor",
		requestedValue: "Valor solicitado",
		liquidAnticipatedValue: "Valor antecipado",
		proRataFee: "Pró rata",
		appliedFee: "Taxa aplicada",
		proRataFeeTooltip: "Taxa de antecipação proporcional ao período do saldo a antecipar",
		totalBruteValue: "Valor bruto total",
		bankAccount: "Conta bancária",
		ticketPayment: "Pagamento de boleto",
		clientObservation: "Motivo",
		obs: "Observação",
		paymentMethod: "Método de pagamento",
		attachments: "Anexos",
		confirmWithdrawBtnLabel: "Confirmar solicitação",
	},
	withdrawType: {
		anticipation: "Antecipação",
		withdraw: "Saque",
		withdrawAndAnticipation: "Saque e Antecipação",
		bankslip: "Boleto",
	},
	statusType: {
		pending: "Pendente",
		paid: "Pago",
		refused: "Negado",
		processing: "Processando",
		pendingPlaceConfirmation: "Aguardando Confirmação",
		cancelled: "Cancelado",
		canceledPlaceConfirmation: "Cancelado",
		processingCancellation: "Processando cancelamento",
		pixProcessing: "Processando Pix",
		bankslipProcessing: "Processando Boleto",
		pendingManagerApproval: "Pendente de aprovação",
		approvedByZigManager: "Aprovado pelo gerente de Zig",
		pendingAnticipation: "Pendente de antecipação",
	},
	paymentType: {
		bankAccount: "Conta bancária",
		bankPaymentSlip: "Pagamento a fornecedores",
	},
	filters: {
		searchAccountPlaceholder: "Buscar por conta",
		filterTypePlaceholder: "Filtrar por tipo",
		filterStatusPlaceholder: "Filtrar por status",
	},
};
